import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { INavItem } from '../../../models/INavItem';

@Component({
  selector: 'ff-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent implements OnInit {
  /**
   * Options to display as navigation items from the top
   * Use the IOption interface: { path: string; label: string; icon: string; }
   * * @internal
   */
  @Input() routes?: INavItem[];

  /**
   * Options to display as navigation items from bottom
   * Use the IOption interface: { path: string; label: string; icon: string; }
   * * @internal
   */
  @Input() routesReverse?: INavItem[];

  /**
   * Options to display as menu items for the top list
   * Use the IMenuOptions interface: { label: string; icon?: string; callback: () => void; args?: any[]; }
   * * @internal
   */
  @Output() navState = new EventEmitter<boolean>();

  isSidenavOpen = false;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  //Toggle control for sidenav
  onSidenavMenuToggle() {
    this.isSidenavOpen = !this.isSidenavOpen;
    this.navState.emit(this.isSidenavOpen);
  }

  //function to navigate between configured routes
  navRoute(route: INavItem) {
    this.isSidenavOpen = false;
    let path = '/' + route.path;
    this.router.navigate([path]);
  }
}
